import useAccountQuery from "@/shared/hooks/useAccountQuery";
import useBranchId from "@/shared/hooks/useBranchId";
import useFranchiseHook from "@/shared/hooks/useFranchiseHook";
import useIsAuth from "@/shared/hooks/useIsAuth";
import useIsKioskUser from "@/shared/hooks/useIsKioskUser";
import useIsWaiterHook from "@/shared/hooks/useIsWaiterHook";
import useLayoutQuery from "@/shared/queries/branch/useLayoutQuery";
import { lazy, PropsWithChildren, Suspense } from "react";
import KioskRoutes from "./KioskRoutes";
import Loader from "./Loader";

const Routes = lazy(() => import("./Routes"));

const AppLoader = ({ children }: PropsWithChildren) => {
  const { isPending } = useLayoutQuery();
  const isAuth = useIsAuth();
  const branch = useBranchId();
  const [franchiseId] = useFranchiseHook();
  // Branch-scoped requests use these ids, so nothing renders until both exist
  const isBranchReady = !!branch && franchiseId > 0;

  const { isPending: isAccountQuery } = useAccountQuery();
  const { showError } = useIsWaiterHook();
  const isKioskUser = useIsKioskUser();

  if (isAuth && isAccountQuery) {
    return <Loader />;
  }

  if (isAuth && (isPending || !isBranchReady || showError)) {
    return <Loader />;
  }

  if (isAuth && isKioskUser) {
    return <KioskRoutes />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <Routes />
    </Suspense>
  );
};

export default AppLoader;
